import { ApprovalStatus } from 'ui-product-approvals-common';
export const getUserCanSkip = ({
  approvalStatus,
  hasApprovalData,
  isSuperAdmin,
  skipApprovalOption,
  usersIdsListThatCanSkipApproval,
  currentUserId
}) => {
  var _usersIdsListThatCanS;
  if (hasApprovalData && (approvalStatus === ApprovalStatus.APPROVAL_PENDING || approvalStatus === ApprovalStatus.CHANGES_REQUESTED)) {
    return false;
  }
  if (isSuperAdmin) {
    return true;
  }
  if (skipApprovalOption) {
    switch (skipApprovalOption) {
      case 'EVERYONE_CAN_SKIP_APPROVAL':
        return true;
      case 'SPECIFIC_LIST_CAN_SKIP_APPROVAL':
        return currentUserId !== undefined ? (_usersIdsListThatCanS = usersIdsListThatCanSkipApproval === null || usersIdsListThatCanSkipApproval === void 0 ? void 0 : usersIdsListThatCanSkipApproval.includes(currentUserId)) !== null && _usersIdsListThatCanS !== void 0 ? _usersIdsListThatCanS : false : false;
      case 'NO_ONE_CAN_SKIP_APPROVAL':
      default:
        return false;
    }
  }
  return false;
};